import { render, staticRenderFns } from "./NavHighlight.vue?vue&type=template&id=4db50776"
import script from "./NavHighlight.vue?vue&type=script&lang=js"
export * from "./NavHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkResolver: require('/home/runner/work/marketing/marketing/components/LinkResolver.vue').default})
